import * as React from "react";

import { BulkyActionPicker, IActionCommand } from "../../../../common/component/action/action-select/bulky-action-picker";
import { ManagePalletActionType } from "../../../constants/constants";
import { observer } from "mobx-react";
import { Permission } from "../../../../context/permission";
import { context } from "../../../../context/context";
import { PalletsListItem } from "../pallets-list/pallets-list-item";

export interface IPalletShippedHeaderProps {
    actionsList: Array<IActionCommand<PalletsListItem, ManagePalletActionType>>;
    reloadPalletList: () => Promise<void>;
}

@observer
export class PalletShippedHeader extends React.Component<IPalletShippedHeaderProps, {}> {

    public render() {
        return <div className="list-actions-container">
            <div className="list-actions">
                <BulkyActionPicker propertyKey={context.warehouseCode}
                                   withScanMode={true}
                                   scanFieldType="text"
                                   inputLabel=""
                                   contentPrefix="palletManagement.action"
                                   actions={this.props.actionsList}
                                   permission={Permission.FrontWrite} />
            </div>
        </div>;
    }
}
